import { createContext } from "react";

export const GlobalContext = createContext({
    "raiseAlert":() => {},
    "clearAlert":() => {},
    "clearStatus":() => {}
});